import { defineMessages } from '@cookbook/solid-intl'

// Split out of `home-page.messages.en.js` so the router's document-title/meta-
// description wiring doesn't have to eagerly pull that entire page's messages file
// into the boot-critical chunk just for these strings. Same pattern/rationale as
// `tos-page-routing.messages.en.js` / `privacy-page-routing.messages.en.js`
// (TENANT-5036 bundle audit).
export const messages = {
    descriptionMessage: defineMessages({
        defaultMessage: 'List your short-term rental on Lodgr. Simple setup, more control over your bookings, and lower fees.',
        id: 'HomePage.descriptionMessage',
    }),
    titleMessage: defineMessages({
        defaultMessage: 'Become a Host – List Your Property | Lodgr',
        id: 'HomePage.titleMessage',
    }),
}
